import colors from './colors';
import { DefaultPaletteOptions } from './types';

const palette: DefaultPaletteOptions = {
  primary: {
    main: colors.xBlue.main,
    light: colors.xBlue.light,
    dark: colors.xBlue.dark,
  },
  secondary: {
    main: colors.xTinny.main,
    light: colors.xTinny.light,
    dark: colors.xTinny.dark,
  },
  tertiary: {
    main: colors.xOrange.main,
    light: colors.xOrange.light,
    dark: colors.xOrange.dark,
  },
  gradient: colors.xSpark,
  xDivider: {
    main: colors.divider.main,
    dark: colors.divider.dark,
  },
  text: {
    primary: colors.text.primary,
    secondary: colors.text.secondary,
    disabled: colors.text.disabled,
    light: colors.text.light,
  },
  background: {
    default: colors.background.default,
    paper: colors.background.paper,
    gradient: colors.background.gradient,
  },
  grey: {
    50: colors.grey.m50,
    100: colors.grey.m100,
    200: colors.grey.m200,
    300: colors.grey.m300,
    400: colors.grey.m400,
    500: colors.grey.m500,
    600: colors.grey.m600,
    700: colors.grey.m700,
    800: colors.grey.m800,
    900: colors.grey.m900,
  },
  error: {
    main: colors.ui.danger.main,
    dark: colors.ui.danger.dark,
    light: colors.ui.danger.light,
  },
  success: {
    main: colors.ui.success.main,
    dark: colors.ui.success.dark,
    light: colors.ui.success.light,
  },
  warning: {
    main: colors.ui.warning.main,
    dark: colors.ui.warning.dark,
    light: colors.ui.warning.light,
  },
  info: {
    main: colors.ui.information.main,
    dark: colors.ui.information.dark,
    light: colors.ui.information.light,
  },
  common: {
    white: colors.text.light,
    black: colors.grey.m900,
  },
  action: {
    disabledBackground: colors.grey.m300,
    disabled: colors.text.disabled,
  },
};

export default palette;
